import React from 'react';

import LeadsRosterResultDesktop from '@presenters/web/pages/Leads/LeadsRosterResult/LeadsDesktopRosterResult';
import LeadsDesktopThreeColumnRosterResult from '@presenters/web/pages/Leads/LeadsRosterResult/LeadsDesktopThreeColumnRosterResult';
import LeadsRosterResultMobile from '@presenters/web/pages/Leads/LeadsRosterResult/LeadsMobileRosterResult';

import { LeadsMMLPage, RosterResultProps } from '../utils';
import RosterResultDesktop from './DesktopRosterResult/index';
import RosterResultMobile from './MobileRosterResult/index';

import { RosterResultRowFragment } from '@typings/operations';

export interface IRosterResulRow
  extends RosterResultRowFragment,
    LeadsMMLPage,
    RosterResultProps {}

const RosterResultRow: React.FC<IRosterResulRow> = props => {
  const { isLeads, isThreeColumn, selectMember, ...prop } = props;
  if (isThreeColumn) {
    return (
      <>
        <LeadsDesktopThreeColumnRosterResult
          selectMember={selectMember}
          {...prop}
        />
        <LeadsRosterResultMobile selectMember={selectMember} {...prop} />
      </>
    );
  }
  if (isLeads) {
    return (
      <>
        <LeadsRosterResultDesktop selectMember={selectMember} {...prop} />
        <LeadsRosterResultMobile selectMember={selectMember} {...prop} />
      </>
    );
  }
  return (
    <>
      <RosterResultDesktop {...prop} />
      <RosterResultMobile {...prop} />
    </>
  );
};

export default RosterResultRow;
